import { render, staticRenderFns } from "./MacroAnalysis.vue?vue&type=template&id=4e540af8&scoped=true"
import script from "./MacroAnalysis.vue?vue&type=script&lang=js"
export * from "./MacroAnalysis.vue?vue&type=script&lang=js"
import style0 from "./MacroAnalysis.vue?vue&type=style&index=0&id=4e540af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e540af8",
  null
  
)

export default component.exports